<template>
  <div v-if="url">
    <div class="pt-8 flex flex-col space-y-4">
      <div class="space-y-2 mx-auto">
        <p class="text-gray-700">Device</p>
        <div class="select-wrapper">
          <select v-model="selected" class="select">
            <option v-for="({ name }, idx) in devices" :value="idx" :key="idx">
              {{ name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div id="wrapper" class="flex-1" :style="{ perspective: view === 'table' ? '1300px' : 'none' }">
      <div
        class="phone"
        :class="[view === 'table' ? 'view_1' : 'view_2']"
        :style="styles"
        id="phone_1"
      >
        <iframe v-show="visible" :src="url" id="frame_1" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagePreview',
  props: {
    url: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    devices: [
      {
        name: 'iPhone 6',
        width: 375,
        height: 667,
      },
      {
        name: 'Samsung Galaxy Note',
        width: 400,
        height: 640,
      },
      {
        name: 'Microsoft Lumia 1020',
        width: 320,
        height: 480,
      },
      {
        name: 'HTC One',
        width: 360,
        height: 640,
      },
      {
        name: 'iPad Mini',
        width: 768,
        height: 1024,
      },
    ],
    selected: 0,
    view: 'front',
    withPerspective: true,
  }),
  computed: {
    device() {
      return this.devices[this.selected];
    },
    styles() {
      if (!this.device) return {};
      return {
        width: `${this.device.width}px`,
        height: `${this.device.height}px`,
      };
    },
  },
};
</script>

<style scoped>
.phone {
  border: 40px solid #121212;
  border-width: 55px 7px;
  border-radius: 40px;
  margin: 50px auto;
  overflow: hidden;
  transition: all 0.5s ease;
  animation: fadein 2s;
}

.phone iframe {
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
}

/*Different Perspectives*/

/* Table View */
.phone.view_1 {
  transform: rotateX(50deg) rotateY(0deg) rotateZ(-30deg);
  box-shadow: -3px 3px 0 #000, -6px 6px 0 #000, -9px 9px 0 #000, -12px 12px 0 #000,
    -14px 10px 20px #000;
}
/* Front View */
.phone.view_2 {
  transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
  box-shadow: 0px 3px 0 #000, 0px 4px 0 #000, 0px 5px 0 #000, 0px 7px 0 #000, 0px 10px 20px #000;
}

@keyframes rotate {
  0% {
    transform: rotateX(50deg) rotateY(0deg) rotateZ(-30deg);
  }
  50% {
    transform: rotateX(50deg) rotateY(0deg) rotateZ(-40deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(0deg) rotateZ(-30deg);
  }
}

/* Rotate Animation */

.view_1.rotate {
  animation-name: rotate;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

/*Controls*/

#controls {
  position: absolute;
  top: 80px;
  left: 20px;
  font-size: 0.9em;
  color: #333;
  width: 17px;
}

#controls div {
  margin: 10px;
}

#controls div label {
  width: 150px;
  display: block;
  float: left;
  color: #fff;
}

#phone-controls {
  position: absolute;
  top: 80px;
  right: 20px;
  width: 200px;
  font-size: 14px;
}

#phones {
  border-top: 1px solid #fff;
  margin-top: 20px;
  padding-top: 20px;
}

@media (max-width: 900px) {
  #wrapper {
    transform: scale(0.8, 0.8);
  }
}

@media (max-width: 700px) {
  #wrapper {
    transform: scale(0.6, 0.6);
  }
}

@media (max-width: 500px) {
  #wrapper {
    transform: scale(0.4, 0.4);
  }
}

/* Fade In Animation */

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
